import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

const DropdownMenu = ({
  items,
  onClose,
  renderCustomComponent,
  title,
  className
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = handlers => () => {
    setAnchorEl(null);
    if (handlers && handlers.length) {
      handlers.forEach(handler => handler && handler());
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClose([onClose])}>
      <button
        type="button"
        className={`outline-0-important ${className}`}
        onClick={handleClick}
      >
        {renderCustomComponent ? (
          renderCustomComponent(!!anchorEl)
        ) : (
          <div aria-controls="simple-menu" aria-haspopup="true">
            {title}
          </div>
        )}
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          transformOrigin={{
            horizontal: "left",
            vertical: "bottom"
          }}
          className="mt-12 ml-3"
          style={{ boxShadow: "none" }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose([onClose])}
        >
          {items.map((item, i) => (
            <MenuItem onClick={handleClose([item.onClick, onClose])} key={i}>
              {item.name}
            </MenuItem>
          ))}
        </Menu>
      </button>
    </ClickAwayListener>
  );
};

DropdownMenu.defaultProps = {
  onClose: null,
  title: "Menu",
  className: ""
};

export default DropdownMenu;
